<template>
  <div :class="computedMainClass">
    <div class="grid-header">
      <el-row :gutter="18" class="mb-3">
        <el-col :span="24" class="table-header">
          <h2 class="ma-0" style="align-self: flex-start;">{{ title }}</h2>
          <span>
            <slot name="actions"></slot>
            <el-input class="searchBox" placeholder="Search" v-model="globalGridSearch"></el-input>
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="grid-wrapper">
      <ag-grid-vue
        class="grid ag-theme-fresh"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :header-height="40"
        :row-height="40"
        @cellDoubleClicked="onCellDoubleClicked"
        @gridReady="onGridReady"
        rowSelection="multiple"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { AgGridVue } from 'ag-grid-vue';

export default {
  props: {
    title: String,
    getRowsPromise: Function,
    columnDefs: Array,
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globalGridSearch: '',
      gridOptions: {
        rowModelType: 'infinite',
        maxBlocksInCache: 20,
        paginationPageSize: 25,
        infiniteInitialRowCount: 75,
        maxConcurrentDatasourceRequests: 3,
        cacheOverflowSize: 50,
        defaultColDef: {
          resizable: true,
          filter: true,
        },
        datasource: {
          getRows: (params) => {
            this.getRowsPromise({
              startRow: params.startRow,
              endRow: params.endRow,
              filterModel: params.filterModel,
              sortModel: params.sortModel,
              globalSearch: this.globalGridSearch,
            }).then((result) => {
              const rows = result.data.rows;
              const total = result.data.total;
              params.successCallback(rows, total);
            }).catch(() => {
              console.error('Get Rows response from server failed.');
            });
          },
        },
        onGridReady($event) { $event.api.sizeColumnsToFit(); },
      },
    };
  },
  methods: {
    onCellDoubleClicked(event) {
      this.$emit('cellDoubleClicked', event);
    },
    onGridReady(event) {
      this.$emit('gridReady', event);
    },
    refreshSearch() {
      this.gridOptions.api.setDatasource(this.gridOptions.datasource);
    },
  },
  computed: {
    computedMainClass() {
      const classes = ['grid-and-header-flex-wrapper'];
      if (this.fixedHeight) {
        classes.push('fixed-height');
      }
      return classes;
    },
  },
  watch: {
    globalGridSearch: debounce(function refreshSearch() {
      this.refreshSearch();
    }, 500),
  },
  components: {
    AgGridVue,
  },
};

</script>

<style lang="scss">

.grid-and-header-flex-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.fixed-height {
    height: 400px;
  }

  .table-header {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;

    > h2 {
      align-self: flex-start;
    }

    > span {
      display: flex;
      flex-direction: row;
      align-self: flex-end;
      align-items: flex-end;
      justify-content: space-between;

      > button {
        margin-right: 18px;
        padding: 11px;
      }

      .searchBox {
        min-width: 300px;
      }
    }
  }

  .grid-wrapper {
    flex: 1;

    .grid {
      height: 100%;
    }
  }
}

</style>
